import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const firebaseRef = firebase.database();

export default function getFormFieldInfo(leadId, path, useAddition) {
	console.log('getFormFieldInfo path', path?.length);

	console.log('getFormFieldInfo path', path);
	var data;

	if (path?.length > 0) {
		var pathKeys = Object.keys(path);
		var pathValue;
		var pathValuesArr = [];

		let clientInfoPathSplit = path[0] && path[0].split('/');
		if (clientInfoPathSplit?.[0] === 'clientInfo') {
			// 1. path === clientInfo
			// (individual case) ex1 - clientInfo / name / 0, ex2 - clientInfo / address / 1,
			// (corporation case) ex1 - clientInfo / name)
			// 2. check clientInfo has individual or corporation
			// 3. get a first name + last name || get a corporation name
			let agreementRef = firebaseRef.ref(
				'/kavtek_agreements/' + PROJECT_CODE.projectCode + '/' + leadId
			);
			agreementRef.once('value', (snapshot) => {
				let snapData = snapshot.val();
				let clientPointer = clientInfoPathSplit?.[2];
				let clientinfoObj = snapData?.clientInfo;
				let clientInfoKey = clientinfoObj && Object.keys(clientinfoObj);
				if (clientInfoKey?.[0] === 'individual') {
					// individual/0/firstName (clientInfo/firstName)
					// individual/0/lastName (clientInfo/lastName)
					// individual/0/address  (clientInfo/address)
					// individual/0/phoneNumber (clientInfo/phonNumber)
					let client = clientinfoObj.individual?.[clientPointer];

					if (client) {
						switch (clientInfoPathSplit?.[1]) {
							case 'name':
								let firstName = client?.firstName;
								let lastName = client?.lastName;
								data = firstName + ' ' + lastName;
								break;
							case 'address':
								data = client?.address1;
								break;
							case 'phone': {
								data = client?.phoneNumber;
								break;
							}
							case 'email': {
								data = client?.email;
								break;
							}
						}
					}
				} else if (
					clientInfoKey?.[0] === 'corporation' &&
					Number(clientPointer) === 0
				) {
					switch (clientInfoPathSplit?.[1]) {
						case 'name':
							data = clientinfoObj.corporation?.corporationName;
							break;
						case 'address':
							data = data = clientinfoObj.corporation?.address1;
							break;
						case 'phone': {
							data = snapData?.leadDetails?.clientPhoneNumber;
							break;
						}
						case 'email': {
							data = snapData?.leadDetails?.clientEmail;
							break;
						}
					}
				}
			});
		} else {
			pathKeys.forEach((key) => {
				console.log('keyyy', path[key]);
				firebaseRef
					.ref(
						'/kavtek_agreements/' +
							PROJECT_CODE.projectCode +
							'/' +
							leadId +
							'/' +
							path[key]
					)
					.once('value', (snapshot) => {
						console.log(
							'getFormFieldInfo snapshot val',
							snapshot.val()
						);
						pathValue = snapshot.val();
						pathValuesArr.push(pathValue);
					});
			});

			console.log('pathvalue w/out del', pathValuesArr.join(' '));
			data = pathValuesArr.join(' ');

			if (useAddition !== undefined && useAddition === true) {
				var dataVal = 0;
				pathValuesArr.forEach((newVal) => {
					dataVal = dataVal + parseFloat(newVal);
				});

				var data = new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: 'USD',
				}).format(dataVal);
			}
		}
	} else {
		firebaseRef
			.ref(
				'/kavtek_agreements/' +
					PROJECT_CODE.projectCode +
					'/' +
					leadId +
					'/' +
					path
			)
			.once('value', (snapshot) => {
				console.log('getFormFieldInfo snapshot val', snapshot.val());
				data = snapshot.val();
			});
	}

	console.log('data', data);
	return data;
}
